<template>
  <!-- 习惯变化 -->
  <div
    class="xgWrap"
    v-if="oneDayData.potentialRiskVo && oneDayData.potentialRiskVo.changeFlag"
  >
    <div>
      <div
        v-for="(item, index) in oneDayData.potentialRiskVo
          .potentialRiskIndexList"
        :key="index"
      >
        <div
          class="xgList"
          v-if="index % 2 == 0"
          :class="{ 'is-alarm': item.normalFlag !== 0 }"
        >
          <div :key="index2" v-for="(item2, index2) in item.reset_titList">
            <div class="xgL_title">
              <div class="point"></div>
              <div class="xgL_title_name">{{ item2.reset_tit }}</div>
            </div>
            <div class="zhanwei">
              <div class="pic">
                <div class="pic-con">
                  <div class="tips-dom">
                    <div class="tips-dom-con">
                      <div>
                        <div class="daliy-str-data">{{ item2.daliyStr }}</div>
                        <div class="str-data">日常数据</div>
                      </div>
                      <div class="tips-dom-con-center"></div>
                      <div>
                        <div class="lately-str-data">{{ item2.latelyStr }}</div>
                        <div class="str-data">最近一天</div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-for="(item3,index3) in item2.data" class="pic-con-item" :style="[{opacity: (item3 < 0 ? 1 :item3)},{background: (item3 === -1 ? '#FFA54D' : '#1890FF')}]"></div> -->
                  <div
                    v-for="(item3, index3) in item2.data"
                    class="pic-con-item"
                    :style="[
                      { opacity: item3 < 0 ? 1 : item3 },
                      { background: item3 === -1 ? '#FFA54D' : '#1890FF' },
                    ]"
                  ></div>
                </div>
                <div class="border-btm"></div>
                <div class="pic-con">
                  <div v-for="(item4, index4) in item2.Xdata" :key="index4">
                    <div
                      class="data-item"
                      v-if="
                        item2.showDataIndex.indexOf(index4) < 0 ? false : true
                      "
                    >
                      <div>{{ item4 }}{{ item4.XDataType }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="deExplain">
            <div class="deExTop" @click="clc_xxjd">
              <div class="deExTopTip">详细解读</div>
              <div class="deExTop_iconWrap">
                <img
                  class="deExTop_icon"
                  v-if="item.isShow_advise"
                  src="../../../assets/img/icon_unscramble_up_h@2x.png"
                  mode="widthFix"
                />
                <img
                  class="deExTop_icon"
                  v-if="!item.isShow_advise"
                  src="../../../assets/img/icon_unscramble_down_h@2x.png"
                  mode="widthFix"
                />
              </div>
            </div>
            <div class="deExCont" v-if="item.isShow_advise">
              <div class="deExContList">
                <div class="dPoint"></div>
                <div class="dWords" v-html="item.reset_unscramble"></div>
              </div>
              <div class="deExContList">
                <div class="dPoint " style="background:#FFA54D"></div>
                <div class="dWords" v-html="item.reset_unscramble2"></div>
              </div>
              <div style="height: 24rpx;"></div>
            </div>
          </div>
          <div class="remindWrap">
            <div class="reTop">
              <div class="rePoint"></div>
              <div class="reTopTips">提醒和建议：</div>
            </div>
            <div class="reAdvice">{{ item.reset_advise }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        v-for="(item, index) in oneDayData.potentialRiskVo
          .potentialRiskIndexList"
        :key="index"
      >
        <div
          class="xgList"
          v-if="index % 2 !== 0"
          :class="{ 'is-alarm': item.normalFlag !== 0 }"
        >
          <div :key="index2" v-for="(item2, index2) in item.reset_titList">
            <div class="xgL_title">
              <div class="point"></div>
              <div class="xgL_title_name">{{ item2.reset_tit }}</div>
            </div>
            <div class="zhanwei">
              <div class="pic">
                <div class="pic-con">
                  <div class="tips-dom">
                    <div class="tips-dom-con">
                      <div>
                        <div class="daliy-str-data">{{ item2.daliyStr }}</div>
                        <div class="str-data">日常数据</div>
                      </div>
                      <div class="tips-dom-con-center"></div>
                      <div>
                        <div class="lately-str-data">{{ item2.latelyStr }}</div>
                        <div class="str-data">最近一天</div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-for="(item3,index3) in item2.data" class="pic-con-item" :style="[{opacity: (item3 < 0 ? 1 :item3)},{background: (item3 === -1 ? '#FFA54D' : '#1890FF')}]"></div> -->
                  <div
                    v-for="(item3, index3) in item2.data"
                    class="pic-con-item"
                    :style="[
                      { opacity: item3 < 0 ? 1 : item3 },
                      { background: item3 === -1 ? '#FFA54D' : '#1890FF' },
                    ]"
                  ></div>
                </div>
                <div class="border-btm"></div>
                <div class="pic-con">
                  <div v-for="(item4, index4) in item2.Xdata" :key="index4">
                    <div
                      class="data-item"
                      v-if="
                        item2.showDataIndex.indexOf(index4) < 0 ? false : true
                      "
                    >
                      <div>{{ item4 }}{{ item4.XDataType }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="deExplain">
            <div class="deExTop" @click="clc_xxjd">
              <div class="deExTopTip">详细解读</div>
              <div class="deExTop_iconWrap">
                <img
                  class="deExTop_icon"
                  v-if="item.isShow_advise"
                  src="../../../assets/img/icon_unscramble_up_h@2x.png"
                  mode="widthFix"
                />
                <img
                  class="deExTop_icon"
                  v-if="!item.isShow_advise"
                  src="../../../assets/img/icon_unscramble_down_h@2x.png"
                  mode="widthFix"
                />
              </div>
            </div>
            <div class="deExCont" v-if="item.isShow_advise">
              <div class="deExContList">
                <div class="dPoint"></div>
                <div class="dWords" v-html="item.reset_unscramble"></div>
              </div>
              <div class="deExContList">
                <div class="dPoint" style="background:#FFA54D"></div>
                <div class="dWords" v-html="item.reset_unscramble2"></div>
              </div>
              <div style="height: 24rpx;"></div>
            </div>
          </div>
          <div class="remindWrap">
            <div class="reTop">
              <div class="rePoint"></div>
              <div class="reTopTips">提醒和建议：</div>
            </div>

            <div class="reAdvice">{{ item.reset_advise }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datasJSON from './../../../utils/data.js';
export default {
  props: {
    oneDayData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.xgbh_data_reset();
  },
  methods: {
    xgbh_data_reset() {
      console.log(this.oneDayData);
      let list = this.oneDayData.potentialRiskVo.potentialRiskIndexList;
      if (!(list && list.length)) {
        return;
      }
      for (let i = 0; i < list.length; i++) {
        let data = list[i].indexData;
        list[i].isShow_advise = false; //详细解读是否显示
        list[i].reset_advise = datasJSON.datasJSON[list[i].indexName]; //建议
        console.log(datasJSON);
        if (list[i].indexName == '上床+起床') {
          let changePicData = this.changePicData(data.getLeaveBedChart.data);
          list[i].reset_titList = [
            {
              reset_tit: '您的上床&起床时间分布如下：',
              data: changePicData,
              Xdata: data.getLeaveBedChart.xdata,
              showDataIndex: data.getLeaveBedChart.index,
              XDataType: '', // min || 次
              daliyStr: `${data.usuallyGetBed}~${data.usuallyLeaveBed}`, // 日常数据
              latelyStr: `${data.latelyGetBed}~${data.latelyLeaveBed}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常上床的时间大致在${data.dailyGetBedSt}</span>到${data.dailyGetBedEd}之间，起床的时间大致在${data.dailyLeaveBedSt}到${data.dailyLeaveBedEd}，通常在<span style="color:#1890FF">${data.usuallyGetBed}</span>上床<span style="color:#1890FF">${data.usuallyLeaveBed}</span>起床；`;
          list[
            i
          ].reset_unscramble2 = `最近一天您是<span style="color:#FFA54D">${data.latelyGetBed}</span>上床<span style="color:#FFA54D">${data.latelyLeaveBed}</span>起床，明显和您日常的习惯有较大差异`;
        } else if (list[i].indexName == '入睡+醒来') {
          let changePicData = this.changePicData(
            data.fallSleepWakeUpChart.data
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的入睡&醒来时间分布如下：',
              data: changePicData,
              Xdata: data.fallSleepWakeUpChart.xdata,
              showDataIndex: data.fallSleepWakeUpChart.index,
              XDataType: '', // min || 次
              daliyStr: `${data.usuallyFallSleep}~${data.usuallyWakeUp}`, // 日常数据
              latelyStr: `${data.latelyFallSleep}~${data.latelyWakeUp}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常入睡的时间大致在${data.dailyFallSleepSt}到${data.dailyFallSleepEd}之间，醒来的时间大致在${data.dailyWakeUpSt}到${data.dailyWakeUpEd}，通常在<span style="color:#1890FF">${data.usuallyFallSleep}</span>入睡<span style="color:#1890FF">${data.usuallyWakeUp}</span>醒来`;
          list[
            i
          ].reset_unscramble2 = `最近一天您是<span style="color:#FFA54D">${data.latelyFallSleep}</span>入睡<span style="color:#FFA54D">${data.latelyWakeUp}</span>醒来，明显和您日常的习惯有较大差异`;
          list[
            i
          ].reset_advise = `是不是发生了什么事情影响了您的正常作息？保持规律的作息时间，可以提高您的睡眠质量哦。建议如果没有特殊情况，还是要按照日常的作息时间上床睡觉哦～`;
        } else if (list[i].indexName == '上床+起床入睡+醒来') {
          let changePicData1 = this.changePicData(data.getLeaveBedChart.data);
          let changePicData2 = this.changePicData(
            data.fallSleepWakeUpChart.data
          );
          list[i].reset_titList = [
            {
              reset_tit: '您上床&起床时间分布如下：',
              data: changePicData1,
              Xdata: data.getLeaveBedChart.xdata,
              showDataIndex: data.getLeaveBedChart.index,
              XDataType: '', // min || 次
              daliyStr: `${data.usuallyGetBed}~${data.usuallyLeaveBed}`, // 日常数据
              latelyStr: `${data.latelyGetBed}~${data.latelyLeaveBed}`, // 最近数据
            },
            {
              reset_tit: '您的入睡&醒来时间分布如下：',
              data: changePicData2,
              Xdata: data.fallSleepWakeUpChart.xdata,
              showDataIndex: data.fallSleepWakeUpChart.index,
              XDataType: '', // min || 次
              daliyStr: `${data.usuallyFallSleep}~${data.usuallyWakeUp}`, // 日常数据
              latelyStr: `${data.latelyFallSleep}~${data.latelyWakeUp}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常上床的时间大致在${data.dailyGetBedSt}</span>到${data.dailyGetBedEd}之间，起床的时间大致在${data.dailyLeaveBedSt}到${data.dailyLeaveBedEd}，通常在<span style="color:#1890FF">${data.usuallyGetBed}</span>上床<span style="color:#1890FF">${data.usuallyLeaveBed}</span>起床；同时，您日常入睡的时间大致在${data.dailyFallSleepSt}到${data.dailyFallSleepEd}之间，醒来的时间大致在${data.dailyWakeUpSt}到${data.dailyWakeUpEd}，通常在<span style="color:#1890FF">${data.usuallyFallSleep}</span>入睡<span style="color:#1890FF">${data.usuallyWakeUp}</span>醒来`;
          list[
            i
          ].reset_unscramble2 = `最近一天您是<span style="color:#FFA54D">${data.latelyGetBed}</span>上床<span style="color:#FFA54D">${data.latelyLeaveBed}</span>起床，<span style="color:#FFA54D">${data.latelyFallSleep}</span>入睡<span style="color:#FFA54D">${data.latelyWakeUp}</span>醒来，明显和您日常的习惯有较大差异`;
        } else if (list[i].indexName.indexOf('入睡时长') != '-1') {
          let resDataToShowX = this.changeShowIndex(
            data.chart.index,
            data.chart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的入睡时长分布如下：',
              data: data.chart.data,
              Xdata: data.chart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}`, // 日常数据
              latelyStr: `${data.latelyIndexVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常入睡时间大致在${data.dailyIndexValSt}</span>到${data.dailyIndexValEd}之间，中位数是<span style="color:#1890FF">${data.dailyIndexValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的入睡时长是<span style="color:#FFA54D">${data.latelyIndexVal}</span>明显和您日常的习惯有较大差异`;
        } else if (list[i].indexName.indexOf('离床时长') != '-1') {
          let resDataToShowX = this.changeShowIndex(
            data.chart.index,
            data.chart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的离床时长分布如下：',
              data: data.chart.data,
              Xdata: data.chart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}`, // 日常数据
              latelyStr: `${data.latelyIndexVal}`, // 最近数据
            },
          ];
          list[i].reset_unscramble =
            data.dailyIndexValMedian == '0分钟'
              ? `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常离床时长大致在0分钟左右`
              : `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常离床时长大致在${data.dailyIndexValSt}</span>到${data.dailyIndexValEd}之间，中位数是<span style="color:#1890FF">${data.dailyIndexValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的离床时长是<span style="color:#FFA54D">${data.latelyIndexVal}</span>明显和您日常的习惯有较大差异`;
        } else if (list[i].indexName.indexOf('离床次数') != '-1') {
          let resDataToShowX = this.changeShowIndex(
            data.chart.index,
            data.chart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的离床次数分布如下：',
              data: data.chart.data,
              Xdata: data.chart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '次', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}次`, // 日常数据
              latelyStr: `${data.latelyIndexVal}次`, // 最近数据
            },
          ];
          if (
            data.dailyIndexValSt == data.dailyIndexValEd &&
            data.dailyIndexValSt == data.dailyIndexValMedian
          ) {
            list[
              i
            ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常离床次数在<span style="color:#1890FF">${data.dailyIndexValSt}次</span>左右`;
          } else {
            list[i].reset_unscramble =
              data.dailyIndexValMedian == 0
                ? `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常离床次数大致在0次左右`
                : `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常离床次数大致在${data.dailyIndexValSt}次</span>到${data.dailyIndexValEd}次之间，中位数是<span style="color:#1890FF">${data.dailyIndexValMedian}次</span>`;
          }
          list[
            i
          ].reset_unscramble2 = `最近一天您的离床次数是<span style="color:#FFA54D">${data.latelyIndexVal}次</span>明显和您日常的习惯有较大差异`;
        } else if (list[i].indexName.indexOf('睡眠时长') != '-1') {
          let resDataToShowX = this.changeShowIndex(
            data.chart.index,
            data.chart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的睡眠时长分布如下：',
              data: data.chart.data,
              Xdata: data.chart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}`, // 日常数据
              latelyStr: `${data.latelyIndexVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常睡眠时长大致在${data.dailyIndexValSt}</span>到${data.dailyIndexValEd}之间，中位数是<span style="color:#1890FF">${data.dailyIndexValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的睡眠时长是<span style="color:#FFA54D">${data.latelyIndexVal}</span>明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '呼吸率1' ||
          list[i].indexName == '呼吸率2'
        ) {
          let resDataToShowX = this.changeShowIndex(
            data.breathChart.index,
            data.breathChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的呼吸率分布如下：',
              data: data.breathChart.data,
              Xdata: data.breathChart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyBreathValSt}~${data.dailyBreathValEd}`, // 日常数据
              latelyStr: `${data.latelyBreathVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您呼吸率大致在${data.dailyBreathValSt}</span>到${data.dailyBreathValEd}之间，中位数是<span style="color:#1890FF">${data.dailyBreathValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的呼吸率是<span style="color:#FFA54D">${data.latelyBreathVal}</span>明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '心率1' ||
          list[i].indexName == '心率2'
        ) {
          let resDataToShowX = this.changeShowIndex(
            data.heartChart.index,
            data.heartChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的心率分布如下：',
              data: data.heartChart.data,
              Xdata: data.heartChart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyHeartValSt}~${data.dailyHeartValEd}`, // 日常数据
              latelyStr: `${data.latelyHeartVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您心率大致在${data.dailyHeartValSt}</span>到${data.dailyHeartValEd}之间，中位数是<span style="color:#1890FF">${data.dailyHeartValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的心率是<span style="color:#FFA54D">${data.latelyHeartVal}</span>明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '体动指数1' ||
          list[i].indexName == '体动指数2'
        ) {
          let resDataToShowX = this.changeShowIndex(
            data.toiChart.index,
            data.toiChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的体动指数分布如下：',
              data: data.toiChart.data,
              Xdata: data.toiChart.xdata,
              showDataIndex: resDataToShowX,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyToiValSt}~${data.dailyToiValEd}`, // 日常数据
              latelyStr: `${data.latelyToiVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您体动指数大致在${data.dailyToiValSt}</span>到${data.dailyToiValEd}之间，中位数是<span style="color:#1890FF">${data.dailyToiValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的体动指数是<span style="color:#FFA54D">${data.latelyToiVal}</span>明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '呼吸率&心率1' ||
          list[i].indexName == '呼吸率&心率2'
        ) {
          let resDataToShowX1 = this.changeShowIndex(
            data.breathChart.index,
            data.breathChart.xdata.length
          );
          let resDataToShowX2 = this.changeShowIndex(
            data.heartChart.index,
            data.heartChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的呼吸率分布如下：',
              data: data.breathChart.data,
              Xdata: data.breathChart.xdata,
              showDataIndex: resDataToShowX1,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}`, // 日常数据
              latelyStr: `${data.latelyIndexVal}`, // 最近数据
            },
            {
              reset_tit: '您的心率分布如下：',
              data: data.heartChart.data,
              Xdata: data.heartChart.xdata,
              showDataIndex: resDataToShowX2,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyIndexValSt}~${data.dailyIndexValEd}`, // 日常数据
              latelyStr: `${data.latelyIndexVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常呼吸率大致在<span style="color:#1890FF">${data.dailyBreathValSt}</span>到<span style="color:#1890FF">${data.dailyBreathValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyBreathValMedian}</span>；心率大致在<span style="color:#1890FF">${data.dailyHeartValSt}</span>到<span style="color:#1890FF">${data.dailyHeartValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyHeartValMedian}</span>；`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的呼吸率是<span style="color:#FFA54D">${data.latelyBreathVal}</span>，心率是<span style="color:#FFA54D">${data.latelyHeartVal}</span>，明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '呼吸率&体动指数1' ||
          list[i].indexName == '呼吸率&体动指数2'
        ) {
          let resDataToShowX1 = this.changeShowIndex(
            data.breathChart.index,
            data.breathChart.xdata.length
          );
          let resDataToShowX2 = this.changeShowIndex(
            data.toiChart.index,
            data.toiChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的呼吸率分布如下：',
              data: data.breathChart.data,
              Xdata: data.breathChart.xdata,
              showDataIndex: resDataToShowX1,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyBreathValSt}~${data.dailyBreathValEd}`, // 日常数据
              latelyStr: `${data.latelyBreathVal}`, // 最近数据
            },
            {
              reset_tit: '您的体动指数分布如下：',
              data: data.toiChart.data,
              Xdata: data.toiChart.xdata,
              showDataIndex: resDataToShowX2,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyToiValSt}~${data.dailyToiValEd}`, // 日常数据
              latelyStr: `${data.latelyToiVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#6844D7">${data.dayNum}</span>天的数据，您日常呼吸率大致在<span style="color:#6844D7">${data.dailyBreathValSt}</span>到<span style="color:#6844D7">${data.dailyBreathValEd}</span>之间，中位数是<span style="color:#6844D7">${data.dailyBreathValMedian}</span>；体动指数大致在<span style="color:#6844D7">${data.dailyToiValSt}</span>到<span style="color:#6844D7">${data.dailyToiValEd}</span>之间，中位数是<span style="color:#6844D7">${data.dailyToiValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的呼吸率是<span style="color:#FFA54D">${data.latelyBreathVal}</span>，体动指数是<span style="color:#FFA54D">${data.latelyToiVal}</span>，明显和您日常的习惯有较大差异，明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '心率&体动指数1' ||
          list[i].indexName == '心率&体动指数2'
        ) {
          let resDataToShowX1 = this.changeShowIndex(
            data.heartChart.index,
            data.heartChart.xdata.length
          );
          let resDataToShowX2 = this.changeShowIndex(
            data.toiChart.index,
            data.toiChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的心率分布如下：',
              data: data.heartChart.data,
              Xdata: data.heartChart.xdata,
              showDataIndex: resDataToShowX1,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyHeartValSt}~${data.dailyHeartValEd}`, // 日常数据
              latelyStr: `${data.latelyHeartVal}`, // 最近数据
            },
            {
              reset_tit: '您的体动指数分布如下：',
              data: data.toiChart.data,
              Xdata: data.toiChart.xdata,
              showDataIndex: resDataToShowX2,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyToiValSt}~${data.dailyToiValEd}`, // 日常数据
              latelyStr: `${data.latelyToiVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常心率大致在<span style="color:#1890FF">${data.dailyHeartValSt}</span>到<span style="color:#1890FF">${data.dailyHeartValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyHeartValMedian}</span>；体动指数大致在<span style="color:#1890FF">${data.dailyToiValSt}</span>到<span style="color:#1890FF">${data.dailyToiValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyToiValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的心率是<span style="color:#FFA54D">${data.latelyHeartVal}</span>，体动指数是<span style="color:#FFA54D">${data.latelyToiVal}</span>，明显和您日常的习惯有较大差异，明显和您日常的习惯有较大差异`;
        } else if (
          list[i].indexName == '心率&呼吸率&体动指数1' ||
          list[i].indexName == '心率&呼吸率&体动指数2'
        ) {
          let resDataToShowX1 = this.changeShowIndex(
            data.breathChart.index,
            data.breathChart.xdata.length
          );
          let resDataToShowX2 = this.changeShowIndex(
            data.heartChart.index,
            data.heartChart.xdata.length
          );
          let resDataToShowX3 = this.changeShowIndex(
            data.toiChart.index,
            data.toiChart.xdata.length
          );
          list[i].reset_titList = [
            {
              reset_tit: '您的呼吸率分布如下：',
              data: data.breathChart.data,
              Xdata: data.breathChart.xdata,
              showDataIndex: resDataToShowX1,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyBreathValSt}~${data.dailyBreathValEd}`, // 日常数据
              latelyStr: `${data.latelyBreathVal}`, // 最近数据
            },
            {
              reset_tit: '您的心率分布如下：',
              data: data.heartChart.data,
              Xdata: data.heartChart.xdata,
              showDataIndex: resDataToShowX1,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyHeartValSt}~${data.dailyHeartValEd}`, // 日常数据
              latelyStr: `${data.latelyHeartVal}`, // 最近数据
            },
            {
              reset_tit: '您的体动指数分布如下：',
              data: data.toiChart.data,
              Xdata: data.toiChart.xdata,
              showDataIndex: resDataToShowX2,
              XDataType: '', // min || 次
              daliyStr: `${data.dailyToiValSt}~${data.dailyToiValEd}`, // 日常数据
              latelyStr: `${data.latelyToiVal}`, // 最近数据
            },
          ];
          list[
            i
          ].reset_unscramble = `综合<span style="color:#1890FF">${data.dayNum}</span>天的数据，您日常呼吸率大致在<span style="color:#1890FF">${data.dailyBreathValSt}</span>到<span style="color:#1890FF">${data.dailyBreathValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyBreathValMedian}</span>；心率大致在<span style="color:#1890FF">${data.dailyHeartValSt}</span>到<span style="color:#1890FF">${data.dailyHeartValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyHeartValMedian}</span>；体动指数大致在<span style="color:#1890FF">${data.dailyToiValSt}</span>到<span style="color:#1890FF">${data.dailyToiValEd}</span>之间，中位数是<span style="color:#1890FF">${data.dailyToiValMedian}</span>`;
          list[
            i
          ].reset_unscramble2 = `最近一天您的呼吸率是<span style="color:#FFA54D">${data.latelyBreathVal}</span>，心率是<span style="color:#FFA54D">${data.latelyHeartVal}</span>，体动指数是<span style="color:#FFA54D">${data.latelyToiVal}</span>，明显和您日常的习惯有较大差异，明显和您日常的习惯有较大差异`;
        }
      }
      this.oneDayData.potentialRiskVo.potentialRiskIndexList = list;
      this.$forceUpdate();
    },

    // 点击详细解读
    clc_xxjd(index, type) {
      if (this.oneDayData.potentialRiskVo.potentialRiskIndexList) {
        //单日习惯变化
        this.oneDayData.potentialRiskVo.potentialRiskIndexList.forEach(
          (item) => {
            item.isShow_advise = !item.isShow_advise;
          }
        );
      } else if (this.oneDayData.potentialRiskVo.sleepIndexList) {
        //单日睡眠指标
        this.oneDayData.potentialRiskVo.sleepIndexList.forEach((item) => {
          item.isShow_advise = !item.isShow_advise;
        });
      } else if (this.oneDayData.potentialRiskVo.breathIndexList) {
        //单日呼吸详情
        this.oneDayData.potentialRiskVo.breathIndexList.forEach((item) => {
          item.isShow_advise = !item.isShow_advise;
        });
      } else if (this.oneDayData.potentialRiskVo.reportIndexList) {
        //多日睡眠指标
        this.oneDayData.potentialRiskVo.reportIndexList.forEach((item) => {
          item.isShow_advise = !item.isShow_advise;
        });
      }

      this.$forceUpdate();
    },
    // 习惯变化数据重置内方法1
    changePicData(data) {
      let resData = data;
      let indexArr = [];
      for (let i = 0; i < resData.length; i++) {
        if (resData[i] === -1) {
          indexArr.push(i);
        }
      }
      console.log(indexArr);
      for (let i = 0; i < indexArr.length; i++) {
        resData.splice(indexArr[i] - 4, 5, -1, -1, -1, -1, -1);
      }
      console.log(resData);
      return resData;
    },

    // 习惯变化数据重置内方法2
    changeShowIndex(data, dataLength) {
      console.log(data, dataLength);
      let resData = [];
      if (dataLength > 20 && dataLength < 30) {
        if (data[1] - data[0] >= 2) {
          resData.push(data[0], data[1]);
        } else {
          resData.push(...[1000000, data[1]]);
        }
        if (data[2] - data[0] > 5 && data[2] - data[1] >= 2) {
          resData.push(data[2]);
        } else {
          resData.splice(1, 2, 100000, data[2]);
        }
      } else if (dataLength > 30 && dataLength < 40) {
        if (data[1] - data[0] >= 4) {
          resData.push(data[0], data[1]);
        } else {
          resData.push(...[1000000, data[1]]);
        }
        if (data[2] - data[0] > 10 && data[2] - data[1] >= 4) {
          resData.push(data[2]);
        } else {
          resData.splice(1, 2, 100000, data[2]);
        }
      } else if (dataLength > 40 && dataLength < 50) {
        if (data[1] - data[0] >= 6) {
          resData.push(data[0], data[1]);
        } else {
          resData.push(...[1000000, data[1]]);
        }
        if (data[2] - data[0] > 15 && data[2] - data[1] >= 6) {
          resData.push(data[2]);
        } else {
          resData.splice(1, 2, 100000, data[2]);
        }
      } else if (dataLength > 50) {
        if (data[1] - data[0] >= 8) {
          resData.push(data[0], data[1]);
        } else {
          resData.push(...[1000000, data[1]]);
        }
        if (data[2] - data[0] > 20 && data[2] - data[1] >= 8) {
          resData.push(data[2]);
        } else {
          resData.splice(1, 2, 100000, data[2]);
        }
      } else {
        resData = data;
      }
      return resData;
    },
  },
};
</script>

<style lang="scss">
.xgWrap {
  display: flex;
  justify-content: space-between;
  .xgList {
    width: 422px;
    height: auto;
    background: #ffffff;
    border-radius: 4px;
    padding: 16px 12px;
    box-sizing: border-box;
    margin: 9px auto 0;
    .xgL_title {
      display: flex;
      align-items: center;
      .point {
        margin-top: 8px;
        width: 8px;
        height: 8px;
        background: #ff7186;
        border-radius: 50%;
      }
      .xgL_title_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1f2635;
        margin-left: 3px;
        margin-top: 8px;
      }
    }
    .zhanwei {
      width: 100%;
      height: 134px;
      // background: pink;
      .pic {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        padding-top: 12px;
        .pic-con {
          width: 100%;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a5a9bc;
          padding-top: 3px;

          display: flex;
          align-items: center;
          justify-content: space-between;
          // margin-left: 20px;
          position: relative;
        }
        .border-btm {
          width: 100%;
          // margin-left: 15px;
          border-bottom: 1px solid #e4e6ec;
        }

        .tips-dom {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 999;
          padding: 8px;
          background: #fff;
          border-radius: 12px;
          border: 1px solid #d4ebff;
          backdrop-filter: blur(1px);
          color: #1f2635;
        }
        .tips-dom-con {
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: left;
          white-space: nowrap;
          line-height: 18px;
          font-size: 14px;
        }
        .tips-dom-con-center {
          width: 2px;
          height: 20px;
          background: #d4ebff;
          margin: 0 12px;
        }
        .tips-dom:before,
        .tips-dom:after {
          content: '';
          display: block;
          border-width: 8px;
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          border-style: solid dashed dashed solid;
          border-color: #d4ebff transparent transparent transparent;
          font-size: 0;
          line-height: 0;
        }
        .tips-dom:after {
          bottom: -15px;
          border-color: #fff transparent transparent transparent;
        }
        .daliy-str-data {
          color: #1890ff;
          font-weight: bold;
        }
        .lately-str-data {
          color: #ffa54d;
        }
        .str-data {
          color: #9094a6;
        }
        .pic-con-item {
          flex: 1;
          height: 100px;
          background: #6844d7;
        }
      }
    }
    .deExplain {
      width: 398px;
      height: auto;

      background: #f3f4f7;
      border-radius: 4px;
      padding: 0 12px;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 8px;
      .deExTop {
        width: 100%;
        height: 45px;
        display: flex;
        align-items: center;
        .deExTopTip {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9094a6;
        }
        .deExTop_iconWrap {
          width: 20px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-left: auto;
          .deExTop_icon {
            width: 14px;
          }
        }
      }

      .deExCont {
        border-top: 1px solid #e8eaed;
        padding-bottom: 10px;
        .deExContList {
          margin-top: 12px;
          display: flex;
          .dPoint {
            width: 12px;
            height: 12px;
            background: #1890ff;
            border-radius: 4px;
            position: relative;
            top: 4px;
          }
          .dWords {
            width: 358px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9094a6;
            margin-left: 4px;
          }
        }
      }
    }

    .remindWrap {
      margin-top: 12px;
      .reTop {
        display: flex;
        align-items: center;
        .rePoint {
          width: 8px;
          height: 8px;
          background: #1890ff;
          border-radius: 50%;
        }
        .reTopTips {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1f2635;
          margin-left: 4px;
        }
      }
      .reAdvice {
        width: 386px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094a6;
        line-height: 20px;
        margin-left: 10px;
        margin-top: 3px;
      }
    }
  }
  .is-alarm {
    border: 1px solid rgba(255, 113, 134, 0.5);
  }
}
</style>
